$(function() {
    var Test = (function() {
        return {
            init: function() {
                this.elements = {
                    root: $('._test')
                };

                this.points = {
                    h: 0,
                    c: 0,
                    b: 0
                };

                if(!this.elements.root.length) return;

                this.bind();
            },
            bind: function () {
                var obj = this,
                    restartBtn = this.elements.root.find('.js-test-re'),
                    startBtn = this.elements.root.find('.js-test-start'),
                    nextBtn = this.elements.root.find('.js-test-next'),
                    prevBtn = this.elements.root.find('.js-test-prev'),
                    goBtn = this.elements.root.find('.js-test-go'),
                    typeBtn = this.elements.root.find('.js-test-type-btn');

                restartBtn.on('click', function() {
                    var context = $(this).parents('.js-test');

                    obj.restart(context);
                    obj.sendGa('new test', 'click', 'one more time');

                    return false;
                });

                typeBtn.on('click', function() {
                    var context = $('.js-test-wrap'),
                        typeScreen = context.find('.js-test-type-select'),
                        type = $(this).data('test-type'),
                        test = context.find('.js-test[data-test-target-type="'+type+'"]').find('.js-questions');

                    typeScreen.removeClass('show');
                    test.addClass('show');

                    if (type == 's') {
                        obj.sendGa('new test', 'click', 'scholar');
                    } else {
                        obj.sendGa('new test', 'click', 'preschooler');
                    }

                    return false;
                });

                startBtn.on('click', function () {
                    var context = $('.js-test-wrap'),
                        intro = context.find('.js-test-intro'),
                        types = context.find('.js-test-type-select');

                    intro.addClass('hide');
                    types.addClass('show');

                    obj.sendGa('start', 'click', 'main screen');

                    return false;
                });

                this.elements.root.find('input[type="radio"]').on('change', function () {
                    var context = $(this).parents('.js-test'),
                        go = context.find('.js-test-go'),
                        currentQ = $(this).parents('.js-question'),
                        n = currentQ.index() + 1;

                    go.addClass('active');
                    obj.changeProgress(context, n);
                    currentQ.addClass('marked');
                });

                nextBtn.add(goBtn).on('click', function () {
                    var context = $(this).parents('.js-test'),
                        n = context.find('.js-question.active').next().index(),
                        scope = context.find('.js-question'),
                        nextSlide = context.find('.js-question.active').next();

                    if ($(this).is('.js-test-next')){
                        obj.sendGa('new test', 'click', 'change question');
                    }

                    if (nextSlide.length) {
                        obj.goToTab(scope, n);
                    } else {
                        obj.calcPoints(context);
                    }

                    return false;
                });

                prevBtn.on('click', function () {
                    var context = $(this).parents('.js-test'),
                        n = context.find('.js-question.active').prev().index(),
                        scope = context.find('.js-question');

                    obj.sendGa('new test', 'click', 'change question');

                    obj.goToTab(scope, n);

                    return false;
                });
            },
            sendGa: function (category, action, label) {
                ga('send', {
                    hitType: 'event',
                    eventCategory: category,
                    eventAction: action,
                    eventLabel: label
                });
            },
            inputChecked: function (context) {
                return context.find('input:checked').length;
            },
            goToTab: function (scope, n) {
                var obj = this,
                    context = scope.parents('.js-test'),
                    go = context.find('.js-test-go'),
                    active;

                scope.removeClass('active');

                $.each(scope, function() {
                    if ($(this).index() == n) {
                        $(this).addClass('active');
                        active = $(this);
                    }
                });

                if (!n) { //if first slide
                    context.find('.js-test-prev').addClass('disabled');
                } else {
                    context.find('.js-test-prev').removeClass('disabled');
                }

                if (!obj.inputChecked(active)) {
                    scope.parents('.js-test').find('.js-test-next').addClass('disabled');
                    go.removeClass('active');
                } else {
                    scope.parents('.js-test').find('.js-test-next').removeClass('disabled');
                    go.addClass('active');
                }
            },
            setProgress: function (context) {
                var _this = this,
                    indicator = context.find('.js-test-progress'),
                    line = indicator.find('.js-test-progress-line'),
                    qCount = context.find('.js-question').length,
                    step = 100 / qCount;

                line.css('width', step+'%');
            },
            changeProgress: function (context, n) {
                var obj = this,
                    indicator = context.find('.js-test-progress'),
                    line = indicator.find('.js-test-progress-line'),
                    qCount = context.find('.js-question').length,
                    step = 100 / qCount,
                    width = parseFloat(line.css('width')),
                    nextPos;

                if (!(context.find('.js-question.active').is('.marked'))) {
                    nextPos = 'calc('+ width + 'px + ' + step +'%)';

                    line.css({
                        'width': '-webkit-'+nextPos,
                        'width': nextPos
                    });

                    obj.sendGa('new test', 'click', 'question-' + n);
                }
            },
            calcPoints: function (context) {
                var obj = this,
                    inputs = context.find('input:checked');

                inputs.each(function () {
                    var type = $(this).data('type');

                    obj.points[type] += 1;
                });

                obj.showResult(context);
            },
            showResult: function (context) {
                var obj = this,
                    max = Math.max.apply(null,Object.keys(obj.points).map(function(x){ return obj.points[x] })),
                    result = Object.keys(obj.points).filter(function(x){ return obj.points[x] == max; })[0];

                if (context.data('test-target-type') == 's') {
                    obj.sendGa('new test', 'click', 'result - scholar - ' + result);
                } else {
                    obj.sendGa('new test', 'click', 'result - preschooler - ' + result);
                }

                context.find('.js-test-result[data-test-result="'+result+'"]').addClass('active');
                context.find('.js-questions').removeClass('show');
                context.find('.js-test-results').addClass('show');
            },
            restart: function (context) {
                var obj = this,
                    wrap = $('.js-test-wrap');

                context.find('input[type="radio"]').prop('checked', false);
                context.find('.js-question').removeClass('active');

                Object.keys(obj.points).forEach(function(key, value) {
                    return obj.points[key] = 0;
                });
                context.find('.js-test-progress-line').css('width', 0);
                context.find('.js-question').first().addClass('active');
                context.find('.js-question').removeClass('marked');
                context.find('.js-test-prev, .js-test-next').addClass('disabled');
                context.find('.js-test-go').removeClass('active');
                context.find('.js-test-result').removeClass('active');
                context.find('.js-test-results').removeClass('show');
                wrap.find('.js-test-intro').removeClass('hide');

                return false;
            }
        }.init();
    })();
});